module.exports = __webpack_public_path__ + "static/media/ic-user-thin-white.280bafe1.svg";